








































































































import { Vue, Prop, Component } from "vue-property-decorator";
import { Test as ITest } from "@/api/models/test";
import { TestPass as ITestPass } from "@/api/models/test-pass";
import { TestPassList as ITestPassList } from "@/api/models/test-pass-list";
import { TestQuestion as ITestQuestion } from "@/api/models/test-question";
import { TestPassResult as ITestPassResult } from "@/api/models/test-pass-result";
import TestPassResult from "@/components/tests/TestPassResult.vue";
import testPass, { TestPassListParams } from "@/getinfo-api/test-pass";
import { getCurrentUserId } from "@/plugins/roles";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { CourseListener as ICourseListener } from "@/api/models/course-listener";
import api from "@/getinfo-api";
import moment from "moment";
import { TestAnswer as ITestAnswer } from "@/api/models/test-answer";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, TestPassResult }
})
export default class TestPassV2 extends Vue {
  @Prop() courseId!: string;
  @Prop() courseLectureId?: string;
  @Prop() testInfo!: ITest;
  @Prop({ default: true }) action!: boolean;
  userAnswers: Array<string> = [];
  testPass!: ITestPass;
  currentQuestion!: ITestQuestion;
  showSpinner: boolean = false;
  result?: ITestPassResult;
  testPassAllCount: number = 0;
  currentTimer!: string;
  globalSpinner: boolean = false;
  listener!: ICourseListener;
  isShowComment: boolean = false;
  isShowCommentSpinner?: boolean = false;
  currentTestPassId: string = "";

  data() {
    return {
      testPass: undefined,
      currentQuestion: undefined,
      result: undefined,
      currentTimer: undefined,
      listener: undefined
    };
  }

  get allQuestionCount() {
    return this.testPass.questions.length;
  }

  get currentQuestionCount() {
    let notPassedQuestions = [];
    this.testPass.questions.forEach(element => {
      if (element.passedAt) {
        notPassedQuestions.push(element);
      }
    });
    return notPassedQuestions.length + 1 < this.testPass.questions.length
      ? notPassedQuestions.length + 1
      : this.testPass.questions.length;
  }

  get isNeedShowComment() {
    return this.testInfo?.testAnswerComment;
  }

  get userId() {
    return getCurrentUserId();
  }

  get testPassType() {
    return this.courseLectureId ? "courseLecture" : "course";
  }

  get canStartTestAgain() {
    return (
      this.testInfo.attemptsCount === 0 ||
      this.testPassAllCount < this.testInfo.attemptsCount
    );
  }

  getNextQuestion() {
    this.getTestPass();
  }

  getComment(value: ITestAnswer) {
    return value ? value.comment : "";
  }

  courseTestStart() {
    api.CourseApi.startTest(this.courseId)
      .then((res: { data: ITestPass }) => {
        this.timeLimit();
        this.testPass = res.data;
        this.currentTestPassId = res.data.id;
        //@ts-ignore
        this.currentQuestion = this.testPass?.questions?.find(el => {
          return !el.passedAt;
        });
        if (!this.currentQuestion) {
          this.finishTest();
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  courseLectureStart() {
    if (this.courseLectureId) {
      api.CourseLectureApi.startTest(this.courseId, this.courseLectureId)
        .then((res: { data: ITestPass }) => {
          this.timeLimit();
          this.testPass = res.data;
          this.currentTestPassId = res.data.id;
          //@ts-ignore
          this.currentQuestion = this.testPass?.questions?.find(el => {
            return !el.passedAt;
          });
          if (!this.currentQuestion) {
            this.finishTest();
          }
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });
        })
        .finally(() => {
          this.showSpinner = false;
        });
    }
  }

  testStart() {
    this.$emit("change");
    this.result = undefined;
    this.showSpinner = true;
    // if (localStorage.getItem("testFinished")) {
    //   localStorage.removeItem("testFinished");
    // }
    if (!this.courseLectureId) {
      this.courseTestStart();
    } else {
      this.courseLectureStart();
    }
  }

  getListenerId() {
    api.CourseApi.listenerGetActiveByUser(this.courseId, this.userId).then(
      (res: { data: ICourseListener }) => {
        this.listener = res.data;
      }
    );
    // .finally(() => {
    //   this.getTestPass();
    // });
  }

  finishTest() {
    this.showSpinner = true;
    if (localStorage.getItem("testFinished")) {
      localStorage.removeItem("testFinished");
    }
    api.TestPassApi.pass(this.testPass?.id)
      .then(() => {
        // location.reload();
        this.getTestPass();
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
        this.globalSpinner = true;
      });
  }

  giveAnswer() {
    if (this.userAnswers.length) {
      // this.showSpinner = true;
      if (this.isNeedShowComment) {
        this.isShowCommentSpinner = true;
      }
      api.TestPassApi.answerToQuestion(
        this.testPass.id,
        this.currentQuestion.id,
        this.userAnswers
      )
        .then(() => {
          const isHasComment = this.currentQuestion?.answers?.some(
            el => el.comment
          );
          if (this.isNeedShowComment && isHasComment) {
            this.isShowComment = true;
          } else {
            this.getTestPass();
          }
        })
        .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
          this.$store.dispatch("errorException", {
            vm: this,
            error: err.response
          });

          if (err.response?.data.message === "Test already finished.") {
            if (localStorage.getItem("testFinished")) {
              localStorage.removeItem("testFinished");
            }
            location.reload();
          }
        })
        .finally(() => {
          this.isShowCommentSpinner = false;
          this.showSpinner = false;
        });
    } else {
      this.$bvToast.toast(this.$tc(this.$translate.ChooseAtLeastOneAnswer), {
        title: this.$tc(this.$translate.Error),
        variant: "danger"
      });
    }
  }

  timeLimit() {
    if (this.testInfo.timeLimit !== 0) {
      let checkFinishedTimestamp: number;
      let limitInMin = this.testInfo.timeLimit * 60 * 1000;
      let currentTime = Date.now();

      if (localStorage.getItem("testFinished")) {
        checkFinishedTimestamp = parseInt(
          //@ts-ignore
          localStorage.getItem("testFinished")
        );
      } else {
        let finishedTime = Date.now() + limitInMin;
        localStorage.setItem("testFinished", finishedTime.toString());
        checkFinishedTimestamp = parseInt(
          //@ts-ignore
          localStorage.getItem("testFinished")
        );
      }

      let diffTime = checkFinishedTimestamp - currentTime;
      let duration: any = moment.duration(diffTime, "milliseconds");
      let interval = 1000;

      let setIntervalId = setInterval(() => {
        duration = moment.duration(duration - interval, "milliseconds");
        this.currentTimer =
          duration.hours() +
          ":" +
          duration.minutes() +
          ":" +
          duration.seconds();
        this.currentTimer = moment
          .utc(duration.as("milliseconds"))
          .format("HH:mm:ss");

        if (duration._milliseconds <= 0) {
          localStorage.removeItem("testFinished");
          clearInterval(setIntervalId);
          this.currentTimer = this.$tc(this.$translate.TimeExpired);
          // this.finishTest();
        }
      }, interval);
    } else {
      this.currentTimer = this.$tc(this.$translate.NotLimited);
    }
  }

  //Получение тестпасса по id теста
  getTestPass() {
    this.isShowCommentSpinner = false;
    this.isShowComment = false;
    this.userAnswers = [];
    this.showSpinner = true;
    //@ts-ignore
    this.currentQuestion = undefined;
    let params: TestPassListParams = {
      ownerId: this.userId,
      targetType: this.testPassType,
      targetId: this.courseLectureId ? this.courseLectureId : this.courseId,
      testeeType: "courseListener",
      testeeId: this.listener ? this.listener.id : undefined,
      limit: 500
    };

    testPass(params)
      .then((res: { data: ITestPassList }) => {
        this.testPassAllCount = res.data.count;
        //@ts-ignore
        this.testPass = res.data.tests?.find(el => {
          return !el.passedAt && this.currentTestPassId === el.id;
        });
        //@ts-ignore
        this.currentQuestion = this.testPass?.questions?.find(el => {
          return !el.passedAt;
        });
        //Если юзер отвечает на все вопросы, то завершаем текущий тестПасс
        if (!this.currentQuestion && this.testPass && !this.testPass.passedAt) {
          this.globalSpinner = true;
          this.showSpinner = true;
          this.finishTest();
        }
        // получаем последний testPass для получения результата
        if (!this.testPass && res.data.tests?.length) {
          this.getResult(res.data.tests);
        }
      })
      .catch((err: AxiosError<IValidationErrorResponse | IErrorResponse>) => {
        this.$store.dispatch("errorException", {
          vm: this,
          error: err.response
        });
      })
      .finally(() => {
        this.showSpinner = false;
      });
  }

  getResult(testPasses: Array<ITestPass>) {
    this.globalSpinner = true;
    let date: number = Date.now();
    let closestTestPass = testPasses.map(el => {
      let timestamp: number = el.passedAt
        ? parseInt(moment(el.passedAt).format("X"))
        : 0;
      return { timestamp, el };
    });
    closestTestPass.sort((a, b) => {
      return Math.abs(date - a.timestamp) - Math.abs(date - b.timestamp);
    });
    api.TestPassApi.getResult(closestTestPass[0].el.id)
      .then((res: { data: ITestPassResult }) => {
        localStorage.removeItem("testFinished");
        this.result = res.data;
      })
      .finally(() => {
        this.globalSpinner = false;
      });
  }

  mounted() {
    this.getListenerId();
  }
}
